import type { ReactNode } from 'react';
import { useTracking } from 'react-tracking';

import If from '@/components/If';

import { MenuLinkNative } from '../MenuLinkNative';
import { MenuItemWrapper, MenuItemHREF, MenuItemRouterLink } from './styled';

interface Props {
  to?: string;
  href?: string;
  label: string | ReactNode;
  target?: string;
  rel?: string;
  notification?: string;
  onClick?: (
    e:
      | React.MouseEvent<HTMLAnchorElement, MouseEvent>
      | React.MouseEvent<HTMLButtonElement, MouseEvent>
      | MouseEvent
      | TouchEvent
  ) => void;
}

const MenuItem = ({ to, href, label, onClick, target, rel }: Props) => {
  const { trackEvent } = useTracking();
  const labelText = typeof label === 'string' ? label : undefined;
  return (
    <MenuItemWrapper data-cy-id={`mobile-more-menu-parent-${label}`}>
      <If
        conditions={{
          spaLink: typeof to === 'string' && to.length > 0,
          internalLink:
            typeof href === 'string' &&
            href.length > 0 &&
            RUNTIME_ENV !== 'native',
          internalLinkNative:
            typeof href === 'string' &&
            href.length > 0 &&
            RUNTIME_ENV === 'native',
        }}
      >
        {{
          spaLink: () => (
            <MenuItemRouterLink
              to={{ type: to! }}
              noUnderline
              inheritColor
              onClick={(e) => {
                onClick && onClick(e);
                trackEvent({
                  action: 'click',
                  modifier: labelText,
                });
              }}
            >
              {label}
            </MenuItemRouterLink>
          ),
          internalLink: () => (
            <MenuItemHREF
              as="a"
              href={href!}
              styleType="softLink"
              target={target}
              rel={rel}
              onClick={(e) => {
                onClick && onClick(e);
                trackEvent({
                  action: 'click',
                  modifier: labelText,
                });
              }}
            >
              {label}
            </MenuItemHREF>
          ),
          internalLinkNative: () => (
            <MenuLinkNative
              href={href!}
              onClick={(e) => {
                onClick && onClick(e);
                trackEvent({
                  action: 'click',
                  modifier: labelText,
                });
              }}
            >
              {label}
            </MenuLinkNative>
          ),
        }}
      </If>
    </MenuItemWrapper>
  );
};

export default MenuItem;
